import AxiosInstance from '../axios.js';

class BrightmallOrdersRequest {
  getOrders(data) {
    return AxiosInstance.post('/brightmall/orders', data);
  }

  getReturns(data) {
    return AxiosInstance.post('/brightmall/orders/return', data);
  }

  getExchanges(data) {
    return AxiosInstance.post('/brightmall/orders/exchange', data);
  }

  requestReturn(data) {
    return AxiosInstance.post('/brightmall/orders/return/request', data);
  }

  confirmReturn(data) {
    return AxiosInstance.post('/brightmall/orders/return/confirm', data);
  }

  registerReturnShipment(data) {
    return AxiosInstance.post('/brightmall/orders/return/shipment', data);
  }
}

export default new BrightmallOrdersRequest();
